import jssVariables from "../../jss_setup";

export const hotels = {
  hotelsList: {
    smallscreen: {
      padding: jssVariables.spacing.center_padding_medium,
    },
  },
};

export const hotelStyles = {
  hotel: {
    borderRadius: jssVariables.normal_gap,
    boxShadow: "1px 3px 9px rgba(0, 0, 0, 0.25)",
  },
  placeholderImg: {
    borderRadius: `${jssVariables.normal_gap} ${jssVariables.normal_gap} 0 0`,
    smallscreen: {
      borderRadius: `${jssVariables.normal_gap} 0 0 ${jssVariables.normal_gap}`,
    },
  },
  imgContainer: {
    smallscreen: {
      borderRadius: `${jssVariables.normal_gap} ${jssVariables.normal_gap} 0 0`,
    },
  },
  img: {
    borderRadius: `${jssVariables.normal_gap} ${jssVariables.normal_gap} 0 0`,
    smallscreen: {
      borderRadius: `${jssVariables.normal_gap} 0 0 ${jssVariables.normal_gap}`,
    },
  },
  imgOverlay: {
    borderRadius: `0 0 ${jssVariables.normal_gap} ${jssVariables.normal_gap} `,
    smallscreen: {
      borderRadius: `${jssVariables.normal_gap} 0 0 ${jssVariables.normal_gap}`,
    },
  },
  contentAndBtmContr: {
    gridTemplateColumns: "1fr",
    smallscreen: {
      gridTemplateColumns: "1fr",
    },
  },
  content: {
    smallscreen: {
      gridColumn: "span 2",
    },
  },
  title: {
    fontSize: "x-large",

    smallscreen: {
      fontSize: "x-large",
    },
  },
  RatingPanel: {
    iconFilled: {
      color: "#fdb211",
    },
  },
};

export const hotelFilters = {
  Filters: {
    borderRadius: jssVariables.border_radius,
  },
};

export const landingPageHotelStyles = {
  hotel: {
    borderRadius: jssVariables.normal_gap,
    boxShadow: "1px 3px 9px rgba(0, 0, 0, 0.25)",
  },
  imgContainer: {
    smallscreen: {
      borderRadius: `${jssVariables.normal_gap} ${jssVariables.normal_gap} 0 0`,
    },
  },
  img: {
    borderRadius: `${jssVariables.normal_gap} ${jssVariables.normal_gap} 0 0`,
    smallscreen: {
      borderRadius: `${jssVariables.normal_gap} 0 0 ${jssVariables.normal_gap}`,
    },
  },
  imgOverlay: {
    borderRadius: `0 0 ${jssVariables.normal_gap} ${jssVariables.normal_gap} `,
    smallscreen: {
      borderRadius: `${jssVariables.normal_gap} 0 0 ${jssVariables.normal_gap}`,
    },
  },
  placeholderImg: {
    borderRadius: `${jssVariables.normal_gap} ${jssVariables.normal_gap} 0 0`,
  },
};

export const hotelBottomContainerMobileView = {
  divider: {
    smallscreen: {
      display: "block",
      width: "100%",
      height: "1px",
      background: jssVariables.colors.border,
      marginLeft: 0,
    },
  },
  buttonStyles: {
    ButtonDefault: {},
    label: {
      fontSize: "large",
    },
  },
};

export const hotelBottomContainer = {
  BottomContainer: {
    gridTemplateColumns: "max-content",
    justifyContent: "end",
    gridGap: jssVariables.half_gap,
    smallscreen: {
      justifyItems: "baseline",
      gridTemplateRows: "1fr",
      gridTemplateColumns: "1fr max-content",
    },
  },
  placeholderParagraph: {
    width: "80vw",
    smallscreen: {
      width: "30rem",
    },
  },
  priceContainer: {
    fontSize: "medium",
  },
  priceTxt: {
    gridGap: jssVariables.half_gap,
    justifyContent: "unset",
  },
  Price: {
    color: jssVariables.colors.text.dark,
    fontSize: "xx-large",
    fontWeight: "normal",
  },
  divider: {
    smallscreen: {
      width: "100%",
      gridColumn: "span 2",
      height: "1px",
      background: jssVariables.colors.border,
      marginLeft: 0,
    },
  },
};

export const PKGFeaturedProduct = {
  bookBtn: {
    background: jssVariables.colors.base_color,
  },
};
export const productStyles = {
  btn: {
    background: jssVariables.colors.base_color,
  },
};

export const hotelSearchDates = {
  header: {
    color: "#8AB547",
  },
};

export const hotelSearchPax = {
  header: {
    color: "#8AB547",
  },
};

export const filtersBarFlights = {
  items: {
    color: jssVariables.colors.text.dark,
  },
  btn: {
    textTransform: "uppercase",
    color: "white",
    fontSize: "medium",
  },
};

export const transferStyles = {
  transfer: {
    gridGap: 0,
    borderRadius: jssVariables.border_radius,
    boxShadow: jssVariables.shadows.smallShadow,
  },
  imgContainer: {
    borderRadius: [
      jssVariables.border_radius,
      jssVariables.border_radius,
      0,
      0,
    ],
    boxShadow: "none",
    smallscreen: {
      borderRadius: [
        jssVariables.border_radius,
        0,
        0,
        jssVariables.border_radius,
      ],
    },
  },
  contentAndBottomContainer: {
    background: "#f3f3f3",
    borderRadius: [
      0,
      0,
      jssVariables.border_radius,
      jssVariables.border_radius,
    ],
    boxShadow: "none",
    smallscreen: {
      borderRadius: [
        0,
        jssVariables.border_radius,
        jssVariables.border_radius,
        0,
      ],
    },
  },
};

export const navbar = {
  item: {
    smallscreen: {
      fontSize: "small",
    },
    bigscreen: {
      fontSize: "medium",
    },
  },
};

export * from "./hotels";
export * from "./footer";
